module.exports = __webpack_public_path__ + "assets/img/picture8.44f67c87.svg";